import { CircleAlert, Copy, HelpCircle, Link2, type LucideIcon, Plus, UserCheck } from 'lucide-react'
import { StatusBadge, type StatusTone } from '@/components/ui/status-badge'
import { STATUS_LABELS } from './rowChoices'
import type { RowStatus } from './types'

/** Shared StatusBadge tones; the label and the icon carry the meaning, never the colour alone. */
const TONES: Record<RowStatus, { tone: StatusTone; icon: LucideIcon }> = {
  nieuw: { tone: 'success', icon: Plus },
  nieuw_org: { tone: 'success', icon: Plus },
  bestaat: { tone: 'info', icon: Link2 },
  bestaat_persoon: { tone: 'info', icon: Link2 },
  founder: { tone: 'warning', icon: UserCheck },
  mogelijk_dubbel: { tone: 'warning', icon: HelpCircle },
  dubbel_in_bestand: { tone: 'neutral', icon: Copy },
  fout: { tone: 'danger', icon: CircleAlert },
}

export function StatusChip({ status }: { status: RowStatus }) {
  const { tone, icon: Icon } = TONES[status]
  return (
    <StatusBadge tone={tone} icon={<Icon />}>
      {STATUS_LABELS[status]}
    </StatusBadge>
  )
}
